<admin-app-header></admin-app-header>
<div class="container-fluid">
    <div class="row">
        <div class="col-3 d-flex align-items-center">
            <h2 class="">1. Invoice Payouts</h2>

            <div aria-label="Basic radio toggle button group" class="btn-group btn-group-sm m-2" role="group"></div>
        </div>
        <div class="col-3 d-flex align-items-center">
            <div>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="showMonthlyPayouts" [(ngModel)]="includeMonthlyMerchants" (change)="applyFilters()" />
                    <label class="form-check-label" for="showMonthlyPayouts">Include Monthly Merchants</label>
                </div>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="showBlankBankDetails" [(ngModel)]="includeBlankBankDetails" (change)="applyFilters()" />
                    <label class="form-check-label" for="showBlankBankDetails">Include Blank Bank Details</label>
                </div>
            </div>
        </div>
        <div class="col-3 d-flex align-items-center">
            <div>
                <div>Merchants Selected: {{ getMerchantsSelected() }}</div>
                <div>Invoices Selected: {{ selectedInvoices.length }}</div>
                <div>Total Amount: {{ getTotalAmount() | currency: 'ZAR' }}</div>
            </div>
        </div>
        <div class="col-3 d-flex align-items-center">
            <button (click)="createPayouts()" class="btn btn-primary btn-sm float-end m-3" type="button" [disabled]="busyCreatingPayouts">
                <span *ngIf="busyCreatingPayouts">
                    <i class="fas fa-spinner fa-spin"></i>
                </span>
                Create Proforma Invoices/s
            </button>
            <!-- <button (click)="globalService.exportcsv('invoices-payouts')" class="btn btn-info btn-sm text-white float-end px-3 py-1 my-2"><i class="fas fa-file-csv"></i> Export to Excel</button> -->
        </div>
    </div>
    <div class="content col-lg-12">
        <table class="table table-striped table-hover table-sm" id="invoices-payouts">
            <thead>
                <tr>
                    <th scope="col">Status</th>
                    <th scope="col">Frequency</th>
                    <!-- <th scope="col">Created Date</th> -->
                    <th scope="col">Due Date</th>
                    <th scope="col">Payment Date</th>
                    <th scope="col">Total</th>
                    <th scope="col">Payout</th>
                    <th scope="col">Fee</th>
                    <th scope="col">Merchant</th>
                    <th scope="col">Parking</th>
                    <th scope="col">Client</th>
                    <th scope="col">Invoice</th>
                    <th scope="col">Bank Details</th>
                    <!-- <th scope="col" class="greyed-out">Bank (OLD)</th> -->
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let invoice of filteredInvoices">
                    <ng-container *ngIf="!invoice.payoutRef || invoice.payoutRef == null">
                        <tr (mousedown)="toggleSelected(invoice)" (mouseenter)="onHoverWithMouseDown($event, invoice)" [class.selected]="selectedInvoices.includes(invoice)">
                            <td>
                                <ng-container *ngIf="invoice.paidOut">
                                    <span class="badge bg-success text-dark">Paid</span>
                                </ng-container>
                                <ng-container *ngIf="!invoice.paidOut">
                                    <span class="badge bg-danger text-light">Not Paid</span>
                                </ng-container>
                            </td>
                            <td>
                                <span
                                    [routerLink]="['/merchant/', invoice.$merchant?.$key, 'profile', 'payout']"
                                    class="badge"
                                    [ngClass]="{
                                        ' bg-success': invoice.$merchant?.payoutDetails?.payoutFrequency === PayoutFrequencyEnum.IMMEDIATE,
                                        ' bg-warning': invoice.$merchant?.payoutDetails?.payoutFrequency === PayoutFrequencyEnum.MONTHLY
                                    }"
                                >
                                    {{ invoice.$merchant?.payoutDetails?.payoutFrequency }}
                                </span>
                            </td>
                            <!-- <td>
                            <a [routerLink]="['/merchant/', invoice.$merchant?.$key, 'invoice', invoice.$key]">
                                {{ invoice.createdAt | formatDate }}
                            </a>
                        </td> -->
                            <td>
                                {{ invoice.dueDate | formatDate }}
                            </td>
                            <td>
                                {{ invoice.paymentDate | formatDate }}
                            </td>
                            <td>
                                {{ invoice.amountTotalDue | formatRands }}
                            </td>
                            <td>
                                <!-- FIXME: Undo this exception -->
                                {{ invoice.periodFinalPayout | formatRands }}
                            </td>
                            <td>
                                <span *ngIf="invoice.$merchant?.commissionPercentage === 0" class="badge bg-danger"> {{ invoice.$merchant?.commissionPercentage }}% </span>
                                <span *ngIf="invoice.$merchant?.commissionPercentage" class="badge bg-warning"> {{ invoice.$merchant?.commissionPercentage }}% </span>
                                <span *ngIf="!invoice.$merchant?.commissionPercentage && invoice.$merchant?.commissionPercentage !== 0" class="badge bg-secondary"> 15% </span>
                            </td>

                            <td>
                                <a [routerLink]="['/merchant/', invoice.$merchant?.$key]" [title]="invoice.$merchant?.companyName" class="text-decoration-underline">
                                    {{ invoice.$merchant?.companyName | slice: 0:15 }}
                                </a>
                            </td>
                            <td>
                                <a [routerLink]="['/parking/', invoice.$parking?.$key]" [title]="invoice.$parking?.title" class="text-decoration-underline">
                                    {{ invoice.denormParkingTitle | slice: 0:15 }}
                                </a>
                            </td>
                            <td>
                                <a [routerLink]="['/client/', invoice.clientRef.id, 'invoices']" class="text-decoration-underline">
                                    {{ invoice.denormClientFirstName || '' }}
                                    {{ invoice.denormClientLastName || '' }}
                                </a>
                            </td>
                            <td>
                                <a href=""
                                   class="invoice-history-link"
                                   (mousedown)="$event.stopPropagation()"
                                   (click)="openInvoiceDetail(invoice, $event)">
                                    INV-{{ invoice.invoiceNumber }}
                                </a>
                            </td>
                            <td>
                                <ng-container *ngIf="invoice.$merchant?.payoutDetails">
                                    <ng-container *ngIf="invoice.$merchant?.payoutDetails?.beneficiaryName">
                                        <span class="badge bg-success text-dark">{{ invoice.$merchant?.payoutDetails?.beneficiaryName }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="!invoice.$merchant?.payoutDetails?.beneficiaryName && invoice.$merchant?.payoutDetails?.accountNumber">
                                        <span class="badge bg-warning text-dark">{{ invoice.$merchant?.payoutDetails?.bank }}: {{ invoice.$merchant?.payoutDetails?.accountNumber }} </span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!invoice.$merchant?.payoutDetails">
                                    <span class="badge bg-danger text-light" [routerLink]="['/merchant', invoice.$merchant?.$key, 'profile', 'payout']">No Bank Details</span>
                                </ng-container>
                            </td>
                            <!-- <td class="greyed-out">
                                <ng-container *ngIf="invoice.$parking?.$bankDetails?.accountHolderName">
                                    <a [routerLink]="['/merchant/', invoice.$merchant?.$key, 'profile', 'payout-details-old']" class="badge bg-info">
                                        OLD: {{ invoice.$parking?.$bankDetails?.accountNumber }}
                                    </a>
                                </ng-container>
                            </td> -->
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>

<!-- Invoice Detail Modal -->
<div class="modal-overlay" *ngIf="showInvoiceDetailModal && modalInvoice" (click)="closeInvoiceDetailModal()">
    <div class="modal-card modal-card--invoice" (click)="$event.stopPropagation()">
        <div class="modal-header modal-header--compact">
            <h2><i class="fa-solid fa-file-invoice-dollar"></i> INV-{{ modalInvoice.invoiceNumber }}</h2>
            <button class="modal-close" type="button" (click)="closeInvoiceDetailModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <div class="invoice-modal-tabs">
            <button type="button" class="invoice-modal-tab" [class.is-active]="modalInvoiceTab === 'overview'" (click)="modalInvoiceTab = 'overview'">Overview</button>
            <button type="button" class="invoice-modal-tab" [class.is-active]="modalInvoiceTab === 'lineItems'" (click)="modalInvoiceTab = 'lineItems'">Line items</button>
        </div>

        <div class="modal-body modal-body--invoice">
            <div class="invoice-tab-pane" *ngIf="modalInvoiceTab === 'overview'">
                <div class="overview-split">
                    <div class="overview-left">
                        <div class="overview-summary-row">
                            <span class="status-badge" [ngClass]="'status-badge--' + modalInvoice.status?.toLowerCase()">{{ modalInvoice.status | titlecase }}</span>
                            <span class="overview-total">{{ modalInvoice.amountTotalDue | formatRands }}</span>
                            <span class="type-badge" [ngClass]="'type-badge--' + modalInvoice.paymentMethodType?.toLowerCase()">{{ EnumNames.getSubscriptionType(modalInvoice.paymentMethodType) }}</span>
                            <span class="overview-meta-chip"><i class="fa-solid fa-car"></i> {{ modalInvoice.baysBooked }} bay(s)</span>
                        </div>

                        <div class="overview-dates-row">
                            <div class="date-cell">
                                <span class="date-stack-k">Created</span>
                                <span class="date-stack-v">{{ modalInvoice.createdAt | formatDate }}</span>
                            </div>
                            <div class="date-cell">
                                <span class="date-stack-k">Due</span>
                                <span class="date-stack-v">{{ modalInvoice.dueDate | formatDate }}</span>
                            </div>
                            <div class="date-cell date-cell--paid">
                                <span class="date-stack-k">Paid</span>
                                <span class="date-stack-v">
                                    <ng-container *ngIf="modalInvoice.paymentDate">{{ modalInvoice.paymentDate | formatDate }}</ng-container>
                                    <span *ngIf="!modalInvoice.paymentDate" class="date-stack-v--muted">—</span>
                                    <span *ngIf="modalInvoice.paidOutDate" class="date-stack-sub">
                                        <span class="date-stack-sep">·</span> Out {{ modalInvoice.paidOutDate | formatDate }}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div class="overview-parties">
                            <div class="overview-party-line">
                                <span class="overview-party-k">Client</span>
                                <a *ngIf="modalInvoice.clientRef" [routerLink]="['/', AngularRoutes.client, modalInvoice.clientRef.id, 'invoices']" class="detail-link" (click)="closeInvoiceDetailModal()">
                                    {{ modalInvoice.denormClientFirstName }} {{ modalInvoice.denormClientLastName }} <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                                <span *ngIf="!modalInvoice.clientRef" class="text-muted">—</span>
                            </div>
                            <div class="overview-party-line" *ngIf="modalInvoice.denormClientCompanyName">
                                <span class="overview-party-k">Company</span>
                                <span>{{ modalInvoice.denormClientCompanyName }}</span>
                            </div>
                            <div class="overview-party-line">
                                <span class="overview-party-k">Portfolio</span>
                                <a *ngIf="modalInvoice.merchantRef" [routerLink]="['/', AngularRoutes.MERCHANT, modalInvoice.merchantRef.id]" class="detail-link" (click)="closeInvoiceDetailModal()">
                                    {{ modalInvoice.denormMerchantCompanyName }} <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                                <span *ngIf="!modalInvoice.merchantRef" class="text-muted">—</span>
                            </div>
                            <div class="overview-party-line">
                                <span class="overview-party-k">Parking</span>
                                <a *ngIf="modalInvoice.parkingRef" [routerLink]="['/', AngularRoutes.parking, modalInvoice.parkingRef.id]" class="detail-link" (click)="closeInvoiceDetailModal()">
                                    {{ modalInvoice.denormParkingTitle }} <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                                <span *ngIf="!modalInvoice.parkingRef" class="text-muted">—</span>
                            </div>
                        </div>

                        <div class="overview-extras">
                            <span *ngIf="modalInvoice.reference" class="overview-extra"><strong>Ref</strong> {{ modalInvoice.reference }}</span>
                            <span *ngIf="modalInvoice.subscriptionRef" class="overview-extra">
                                <strong>Sub</strong>
                                <a [routerLink]="['/admin', 'subscription', modalInvoice.subscriptionRef.id]" class="detail-link" target="_blank">{{ modalInvoice.subscriptionRef.id | slice:0:10 }}… <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                            </span>
                            <span *ngIf="modalInvoice.paygateAttempts" class="overview-extra"><strong>PG</strong> {{ modalInvoice.paygateAttempts }}</span>
                            <span class="overview-extra"><strong>Paid out</strong> {{ modalInvoice.paidOut ? 'Yes' : 'No' }}</span>
                            <span *ngIf="modalInvoice.$key" class="overview-extra overview-extra--id"><strong>ID</strong> {{ modalInvoice.$key }}</span>
                        </div>
                    </div>

                    <aside class="overview-history">
                        <h4 class="overview-history__title"><i class="fa-solid fa-clock-rotate-left"></i> Invoice history</h4>
                        <div class="logs-loading" *ngIf="modalChangeLogsLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading…</div>
                        <div class="logs-error" *ngIf="!modalChangeLogsLoading && modalChangeLogsError">{{ modalChangeLogsError }}</div>
                        <div class="logs-empty" *ngIf="!modalChangeLogsLoading && !modalChangeLogsError && modalChangeLogs.length === 0">No admin changes logged.</div>
                        <ul class="logs-list logs-list--compact" *ngIf="!modalChangeLogsLoading && !modalChangeLogsError && modalChangeLogs.length > 0">
                            <li *ngFor="let log of modalChangeLogs" class="log-item">
                                <span class="log-date">{{ log.createdAt | formatDate }}</span>
                                <span class="log-text">{{ log.comment }}</span>
                            </li>
                        </ul>
                    </aside>
                </div>
            </div>

            <div class="invoice-tab-pane invoice-tab-pane--line-items" *ngIf="modalInvoiceTab === 'lineItems'">
                <div class="line-items-empty" *ngIf="!modalInvoice.lineItems?.length">
                    <p>No line items on this invoice.</p>
                </div>
                <table class="line-items-table line-items-table--tab" *ngIf="modalInvoice.lineItems?.length">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Qty</th>
                            <th>Unit</th>
                            <th>VAT</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of modalInvoice.lineItems">
                            <td>{{ item.description }}</td>
                            <td class="text-center">{{ item.quantity }}</td>
                            <td class="text-right">{{ item.unitPrice | formatRands }}</td>
                            <td class="text-center">{{ item.vatRateName }}</td>
                            <td class="text-right">{{ item.lineTotal | formatRands }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="4" class="text-right"><strong>Subtotal (excl. VAT)</strong></td>
                            <td class="text-right">{{ modalInvoice.totalExcludingVAT | formatRands }}</td>
                        </tr>
                        <tr>
                            <td colspan="4" class="text-right"><strong>VAT</strong></td>
                            <td class="text-right">{{ modalInvoice.totalVAT | formatRands }}</td>
                        </tr>
                        <tr class="total-row">
                            <td colspan="4" class="text-right"><strong>Total due</strong></td>
                            <td class="text-right"><strong>{{ modalInvoice.amountTotalDue | formatRands }}</strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="modal-footer modal-footer--compact">
            <a *ngIf="modalInvoice.clientRef" [routerLink]="['/', AngularRoutes.client, modalInvoice.clientRef.id, 'invoices']" class="btn btn-primary" (click)="closeInvoiceDetailModal()">
                <i class="fa-solid fa-user"></i> View client record
            </a>
            <a *ngIf="modalInvoice.clientRef" [routerLink]="['/client', modalInvoice.clientRef.id, AngularRoutes.INVOICE, modalInvoice.$key]" class="btn btn-secondary" (click)="closeInvoiceDetailModal()">
                <i class="fa-solid fa-file-invoice"></i> Full invoice page
            </a>
            <button type="button" class="btn btn-secondary" (click)="closeInvoiceDetailModal()">Close</button>
        </div>
    </div>
</div>
